import React from 'react';

export default function PageLoader() {
  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
      <div className="text-center">
        {/* Britedge Logo */}
        <div className="mb-8 animate-pulse">
          <img 
            src="https://britedgeng.com/images/logo.png" 
            alt="Britedge" 
            className="h-16 w-auto mx-auto"
          />
        </div>

        {/* Animated Spinner */}
        <div className="relative w-16 h-16 mx-auto mb-6">
          <div className="absolute inset-0 border-4 border-blue-100 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-brand-blue rounded-full animate-spin"></div>
        </div>

        {/* Loading Text */}
        <p className="text-slate-600 font-medium animate-pulse">Loading...</p>
      </div>
    </div>
  );
}

// Alternative minimal loader
export const MinimalLoader = () => {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="relative w-12 h-12">
        <div className="absolute inset-0 border-4 border-blue-100 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-transparent border-t-brand-blue rounded-full animate-spin"></div>
      </div>
    </div>
  );
};
